import Layout from "../components/Layout";
import { useEffect, useState } from "react";
import axios from "axios";
import {useSelector} from "react-redux";
import { BASE_URL } from "../utils/commonUrl";
import DashboardTableItem from "../components/DashboardTableItem";
import ValueAssessmentChart from "./DashboardChart/ValueAssessmentChart";
import CoreAssessmentChart from "./DashboardChart/CoreAssessmentChart";
import MatrixAssessmentChart from "./DashboardChart/MatrixAssessmentChart";
import {ProgressSpinner} from "primereact/progressspinner";
import QuarterNames from "../components/QuarterNames";

const ManagementDashboard = () => {
  const {user} = useSelector((state) => state["auth"]);
  const [dashboardSummaryData, setDashboardSummaryData] = useState([]);
  const [selectedQuarterID, setSelectedQuarterID] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setSelectedQuarterID(user.quarterID);
    GetDashboardSummaryData(user.quarterID);
  }, []);

  const GetDashboardSummaryData = (id) => {
    setIsLoading(true);    
    axios
      .post(BASE_URL + `/api/dashboard/GetDashboardSummaryData/${id}`)
      .then((response) => {
        console.log(response.data);
        setDashboardSummaryData(response.data);        
        setIsLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
     
  };

  const childToParent = () => {
    setSelectedQuarterID(document.getElementById('ddlQuarter').value);
    GetDashboardSummaryData(document.getElementById('ddlQuarter').value);
  }


  return (
    <Layout>
      <div className="bd-example">
      <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">
                <h6><i class="bi bi-people-fill"></i> Management Dashboard</h6>
                <div className="col-md-4">
                    <QuarterNames childToParent={childToParent}/>
                </div>
            </div>
            <div className="card-body">
        {isLoading ? <ProgressSpinner style={ {height:50,width:50} }/> : 
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
        
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="pills-home-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-home"
              type="button"
              role="tab"
              aria-controls="pills-home"
              aria-selected="true"
            >
              <i class="bi bi-building"></i> Factory Status
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="pills-profile-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-profile"
              type="button"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
            >
              <i class="bi bi-file-earmark-bar-graph"></i> Information Graph
            </button>
          </li>
          
        </ul>}
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <div className="row">
              {dashboardSummaryData.map((value, index) => (
                <DashboardTableItem key={index} data={value} />
              ))}
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="pills-profile"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
          >
            <div className="row">
              <div className="col-md-6">
                <ValueAssessmentChart quarterID={selectedQuarterID} />
              </div>
              <div className="col-md-6">
                <CoreAssessmentChart quarterID={selectedQuarterID} />
              </div>              
            </div>
            <div className="row">
              <div className="col-md-12">
                <MatrixAssessmentChart quarterID={selectedQuarterID} />
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
      
    </Layout>
  );
};

export default ManagementDashboard;
